// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jd-co-bo-st {
    width: 100%;
    height: auto;
}

.scl--jcbst-hea-bo-st {
    width: 100%;
    min-height: 162px;
    margin-top: 110px;
    display: flex;
    justify-content: center;
}

.scl--jhbs-pad-cons-bo-stl {
    width: 100%;
    max-width: var(--global-desktop-width-resp);
    padding-left: var(--global-desktop-padding-left);
    padding-right: var(--global-desktop-padding-right);
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.scl--jhbs-but-bo-st {
    min-width: 192px;
    height: 24px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.scl--jhbs-but-bo-st span {
    font-size: 18px;
    font-family: var(--primary-font);
    color: rgba(125, 129, 135, 1);
    padding-bottom: 4px;
}

.scl--jhbs-her-hea-st {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
}

.scl--jhhs-des-sty {
    width: 80%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.scl--jhhs-des-sty h5 {
    margin: 0px;
    padding: 0px;
    min-height: 95px;
    font-family: var(--primary-font);
    font-size: 60px;
    font-weight: 500;
    padding-bottom: 15px;
}

.scl--jds-tim-loc-st {
    width: 100%;
    min-height: 20px;
    display: flex;
    align-items: center;
    gap: 14px;
}

.scl--jds-tim-loc-st span {
    font-size: 18px;
    color: rgba(125, 129, 135, 1);
    font-family: var(--primary-font);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.scl--jtls-loc-sty {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.scl--jtls-tim-sty {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

.scl--jhhs-but-sty {
    width: 20%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
}

.scl--jd-btn-hea-st {
    min-width: 134px;
    height: 40px;
    background: linear-gradient(269.77deg,
            #ffffff 33.81%,
            #adadad 89.95%,
            #dddddd 126.9%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.scl--jd-btn-hea-st .scl--web-component-round-button-icon svg {
    width: 20px;
    height: 20px;
}

.scl--jd-btn-hea-st:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border: 1.5px solid rgba(121, 121, 121, 1);
    -webkit-text-fill-color: initial;
}

.scl--jcbs-det-met-st {
    width: 100%;
    height: auto;

    display: flex;
    justify-content: center;
}

.scl--jdms-bo-con-wid-st {
    padding-left: var(--global-desktop-padding-left);
    padding-right: var(--global-desktop-padding-right);
    padding-top: 20px;
    padding-bottom: 50px;
    width: 100%;
    max-width: var(--global-desktop-width-resp);
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.scl--jdms-eac-met-da-st {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.scl--jemds-ti-tex-st {
    font-size: 24px;
    font-family: var(--primary-font);
    font-weight: lighter;
    color: rgba(255, 255, 255, 1);
}

.scl--jdms-eac-met-da-st p {
    color: rgba(150, 158, 170, 1);
    font-size: 18px;
    font-family: var(--primary-font);
}

.scl--jdms-eac-met-da-st .standalone-description {
    color: rgba(150, 158, 170, 1);
    font-size: 18px;
    font-family: var(--primary-font);
    line-height: 30px;
}

.scl--jemds-par-tex-st {
    color: rgba(150, 158, 170, 1);
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: 274;
    padding: 0px;
    margin: 0px;
    line-height: 30px;
}

.scl--jdms-eac-met-da-st ul {
    list-style: none;
    padding-left: 25px;
}

.scl--jdms-eac-met-da-st ul li {
    color: rgba(150, 158, 170, 1);
    font-size: 18px;
    font-family: var(--primary-font);
    padding: 0px;
    margin: 0px;
    line-height: 30px;
    position: relative;
}

.scl--jdms-eac-met-da-st li::before {
    content: "•";
    position: absolute;
    left: -13px;
    font-size: 15px;
    top: 50%;
    transform: translateY(-50%);
}

.scl--jcbs-for--sub-jb-stl {
    width: 100%;
    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
    display: flex;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobDetail.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,gDAAgD;IAChD,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;;IAEhC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;;;2BAGuB;IACvB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gDAAgD;IAChD,kDAAkD;IAClD,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,mEAAmE;IACnE,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[".scl--jd-co-bo-st {\n    width: 100%;\n    height: auto;\n}\n\n.scl--jcbst-hea-bo-st {\n    width: 100%;\n    min-height: 162px;\n    margin-top: 110px;\n    display: flex;\n    justify-content: center;\n}\n\n.scl--jhbs-pad-cons-bo-stl {\n    width: 100%;\n    max-width: var(--global-desktop-width-resp);\n    padding-left: var(--global-desktop-padding-left);\n    padding-right: var(--global-desktop-padding-right);\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.scl--jhbs-but-bo-st {\n    min-width: 192px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0px;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.scl--jhbs-but-bo-st span {\n    font-size: 18px;\n    font-family: var(--primary-font);\n    color: rgba(125, 129, 135, 1);\n    padding-bottom: 4px;\n}\n\n.scl--jhbs-her-hea-st {\n    width: 100%;\n    height: auto;\n    display: flex;\n    justify-content: space-between;\n}\n\n.scl--jhhs-des-sty {\n    width: 80%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.scl--jhhs-des-sty h5 {\n    margin: 0px;\n    padding: 0px;\n    min-height: 95px;\n    font-family: var(--primary-font);\n    font-size: 60px;\n    font-weight: 500;\n    padding-bottom: 15px;\n}\n\n.scl--jds-tim-loc-st {\n    width: 100%;\n    min-height: 20px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.scl--jds-tim-loc-st span {\n    font-size: 18px;\n    color: rgba(125, 129, 135, 1);\n    font-family: var(--primary-font);\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.scl--jtls-loc-sty {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.scl--jtls-tim-sty {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n}\n\n.scl--jhhs-but-sty {\n    width: 20%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.scl--jd-btn-hea-st {\n    min-width: 134px;\n    height: 40px;\n    background: linear-gradient(269.77deg,\n            #ffffff 33.81%,\n            #adadad 89.95%,\n            #dddddd 126.9%);\n    background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.scl--jd-btn-hea-st .scl--web-component-round-button-icon svg {\n    width: 20px;\n    height: 20px;\n}\n\n.scl--jd-btn-hea-st:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    border: 1.5px solid rgba(121, 121, 121, 1);\n    -webkit-text-fill-color: initial;\n}\n\n.scl--jcbs-det-met-st {\n    width: 100%;\n    height: auto;\n\n    display: flex;\n    justify-content: center;\n}\n\n.scl--jdms-bo-con-wid-st {\n    padding-left: var(--global-desktop-padding-left);\n    padding-right: var(--global-desktop-padding-right);\n    padding-top: 20px;\n    padding-bottom: 50px;\n    width: 100%;\n    max-width: var(--global-desktop-width-resp);\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.scl--jdms-eac-met-da-st {\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.scl--jemds-ti-tex-st {\n    font-size: 24px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n    color: rgba(255, 255, 255, 1);\n}\n\n.scl--jdms-eac-met-da-st p {\n    color: rgba(150, 158, 170, 1);\n    font-size: 18px;\n    font-family: var(--primary-font);\n}\n\n.scl--jdms-eac-met-da-st .standalone-description {\n    color: rgba(150, 158, 170, 1);\n    font-size: 18px;\n    font-family: var(--primary-font);\n    line-height: 30px;\n}\n\n.scl--jemds-par-tex-st {\n    color: rgba(150, 158, 170, 1);\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: 274;\n    padding: 0px;\n    margin: 0px;\n    line-height: 30px;\n}\n\n.scl--jdms-eac-met-da-st ul {\n    list-style: none;\n    padding-left: 25px;\n}\n\n.scl--jdms-eac-met-da-st ul li {\n    color: rgba(150, 158, 170, 1);\n    font-size: 18px;\n    font-family: var(--primary-font);\n    padding: 0px;\n    margin: 0px;\n    line-height: 30px;\n    position: relative;\n}\n\n.scl--jdms-eac-met-da-st li::before {\n    content: \"•\";\n    position: absolute;\n    left: -13px;\n    font-size: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.scl--jcbs-for--sub-jb-stl {\n    width: 100%;\n    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n    display: flex;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
